import React from 'react';
import T from 'prop-types';

const PreviewTopBanner = ({ campaignEnded }) => {
  if (campaignEnded) {
    return (
      <div className="public-preview-banner public-preview-banner--top public-preview-banner--ended">
        <div className="public-preview-banner__inner">
          <div className="public-preview-banner__text-group">
            <h2 className="public-preview-banner__title">This view expired</h2>
            <p className="public-preview-banner__subtitle">
              The Gen AI Insights dashboard was available until April 23. Talk with a human to get
              full, uninterrupted access to real-time data and complete app coverage of the most
              influential companies.
            </p>
          </div>
          <a
            className="btn btn-primary public-preview-banner__cta"
            href="https://apptopia.com/en/ai-dashboard-requests"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="public-preview-banner public-preview-banner--top">
      <div className="public-preview-banner__inner">
        <div className="public-preview-banner__text-group">
          <h2 className="public-preview-banner__title">Live data will expire on April 23rd</h2>
          <p className="public-preview-banner__subtitle">
            This dashboard is only available until 11:59pm ET on April 23. Talk with a human to get
            full, uninterrupted access to real-time data and complete app coverage of the most
            influential companies.
          </p>
        </div>
        <a
          className="btn btn-primary public-preview-banner__cta"
          href="https://apptopia.com/en/ai-dashboard-requests"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
};

PreviewTopBanner.propTypes = {
  campaignEnded: T.bool.isRequired,
};

export default PreviewTopBanner;
